export default function({ route }): void {
    if (route.fullPath === '/' || route.fullPath === '') {
        route.params.slug = '/';
    }
}
